import { FC } from 'react'
import classNames from 'classnames'

import { Link } from '../../../navigation/custom-react-router-dom'
import { AlertIconWrapper } from '../../AlertIconWrapper/AlertIconWrapper'
import { TextSmall } from '../../Typography/Typography'

import styles from './PageSectionTabs.module.scss'

export interface Tab {
  label: string
  path: string
  alert?: boolean
}

export interface PageSectionTabsProps {
  tabs: Tab[]
  activePath?: string
  onTabClick?: (tab: Tab) => void
}

export const PageSectionTabs: FC<PageSectionTabsProps> = (props) => {
  const { tabs, onTabClick, activePath = '' } = props

  return (
    <div className={styles.pageSectionTabs}>
      {tabs.map((tab) => (
        <Link
          to={tab.path}
          key={tab.label}
          className={classNames(styles.tab, { [styles.active]: tab.path.includes(activePath) })}
        >
          <AlertIconWrapper fullWidth spaced isActive={tab.alert}>
            <TextSmall className={styles.label} onClick={() => onTabClick?.(tab)}>
              {tab.label}
            </TextSmall>
          </AlertIconWrapper>
        </Link>
      ))}
    </div>
  )
}
